export const isDevelopment = import.meta.env.VITE_MODE === 'development';
export const isProduction = import.meta.env.VITE_MODE === 'production';
export const isPreview = import.meta.env.VITE_MODE === 'preview';
